import { header } from "./modules/common/header";
import { anchorlink } from "./modules/common/anchorlink";
import { scrollanimation } from "./modules/common/scrollanimation";

header();
anchorlink();
scrollanimation();
